import { useCallback, useEffect, useState } from "react";
import { execService } from "@/services";
import { apiErrorMessage } from "@/lib/api";
import { toast } from "sonner";
import { Megaphone, Loader2 } from "lucide-react";
import {
  useTenantScope, TenantPicker, SelectTenantNotice, PageHeader, PeriodSelector, KpiTile, DrilldownPanel, Distribution,
} from "./shared";
import { AiExecutiveSummary } from "./AiExecutiveSummary";

export default function MarketingLeadershipDashboard() {
  const scope = useTenantScope();
  const { isSuper, tenantId, params } = scope;
  const [period, setPeriod] = useState("30d");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [drill, setDrill] = useState(null);
  const blocked = isSuper && !tenantId;

  const load = useCallback(() => {
    if (blocked) { setData(null); return; }
    setLoading(true);
    execService.marketing({ ...params, period }).then(setData).catch((e) => toast.error(apiErrorMessage(e.response?.data?.detail))).finally(() => setLoading(false));
  }, [blocked, params, period]);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="exec-marketing-page">
      <PageHeader icon={Megaphone} title="Marketing Leadership" subtitle="Campaign reach, engagement and channel performance.">
        <PeriodSelector period={period} setPeriod={setPeriod} />
        <TenantPicker {...scope} />
      </PageHeader>

      {blocked ? <SelectTenantNotice /> : loading && !data ? (
        <div className="flex items-center justify-center py-20 text-muted-foreground"><Loader2 className="h-6 w-6 animate-spin" /></div>
      ) : data ? (
        <div className="space-y-5">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {data.tiles.map((t) => <KpiTile key={t.key} tile={t} onDrill={(m, l) => setDrill({ metric: m, label: l })} />)}
          </div>
          <div className="grid lg:grid-cols-2 gap-4">
            <Distribution title="Campaigns by channel" data={data.byChannel} testid="mkt-by-channel" />
            <Distribution title="Campaigns by status" data={data.byStatus} testid="mkt-by-status" />
          </div>
          <AiExecutiveSummary period={period} params={params} />
        </div>
      ) : null}

      {drill && <DrilldownPanel metric={drill.metric} label={drill.label} params={params} onClose={() => setDrill(null)} />}
    </div>
  );
}
